import { IconAdvancedClipboard as Clipboard } from './IconAdvancedClipboard/IconAdvancedClipboard'
import { IconAdvancedFilters as Filters } from './IconAdvancedFilters/IconAdvancedFilters'
import { IconAdvancedRoot as Root } from './IconAdvancedRoot/IconAdvancedRoot'

export const IconAdvanced = { Clipboard, Filters, Root }
